import { jsx as _jsx } from "react/jsx-runtime";
import { Paragraph as UIParagraph } from '@phishtool/ui';
export const Paragraph = (props) => _jsx(UIParagraph, Object.assign({}, props, { letterSpacing: true }));
